import {
  TicketsIcon,
  FolderIcon,
  TagIcon,
  UserAvatarIcon,
} from '@/config/icons';
import { cn } from '@/lib/utils';

interface CollapsedSidebarProps {
  totalTickets: number;
  currentCategoryId: string | null;
  currentTagId: string | null;
  currentAgentId: string | null;
  onAllTicketsClick: () => void;
  onExpand: () => void;
}

export function CollapsedSidebar({
  totalTickets,
  currentCategoryId,
  currentTagId,
  currentAgentId,
  onAllTicketsClick,
  onExpand,
}: CollapsedSidebarProps) {
  return (
    <div className="p-2 space-y-2">
      <button
        onClick={onAllTicketsClick}
        className={cn(
          "flex items-center justify-center p-2 rounded-lg transition-colors relative w-full",
          !currentCategoryId && !currentTagId && !currentAgentId
            ? "bg-muted text-foreground"
            : "text-muted-foreground hover:text-foreground hover:bg-muted"
        )}
        aria-label="Tous les tickets"
      >
        <TicketsIcon className="h-4 w-4" />
        {totalTickets > 0 && (
          <span className="absolute -top-1 -right-1 h-4 w-4 bg-luminjo-pink text-white text-[10px] rounded-full flex items-center justify-center">
            {totalTickets > 99 ? '99+' : totalTickets}
          </span>
        )}
      </button>
      <button
        onClick={onExpand}
        className="flex items-center justify-center p-2 rounded-lg text-muted-foreground hover:text-foreground hover:bg-muted transition-colors w-full"
        aria-label="Ouvrir les dossiers"
      >
        <FolderIcon className="h-4 w-4" />
      </button>
      <button
        onClick={onExpand}
        className="flex items-center justify-center p-2 rounded-lg text-muted-foreground hover:text-foreground hover:bg-muted transition-colors w-full"
        aria-label="Ouvrir les tags"
      >
        <TagIcon className="h-4 w-4" />
      </button>
      <button
        onClick={onExpand}
        className="flex items-center justify-center p-2 rounded-lg text-muted-foreground hover:text-foreground hover:bg-muted transition-colors w-full"
        aria-label="Ouvrir les agents"
      >
        <UserAvatarIcon className="h-4 w-4" />
      </button>
    </div>
  );
}
